import { Text } from '@/ui-kit'
import { formatNumber } from '@/utils'
import { useFetchUser } from '../authorization/api/useFetchUser'

export const ProfileInfoBlock = () => {
  const { data: user } = useFetchUser(true)

  return (
    <div className="max-tablet:pr-0 max-mobile:w-[unset] w-[270px] pr-10">
      <Text type="subtitle-semibold">Profile</Text>
      <div className="mt-3 flex flex-col gap-4">
        <div className="flex flex-col border-b border-solid border-gray-100 pb-4">
          <Text className="text-gray-90">Total points</Text>
          <Text className="color" type="h2">
            {user ? formatNumber(user.points || 0, 0) : '-'}
          </Text>
        </div>
        <div className="flex flex-col pb-4">
          <Text className="text-gray-90">Email</Text>
          <Text>{user?.email || '-'}</Text>
        </div>
      </div>
    </div>
  )
}
